<template>
  <div class="draw">
    <div class="specification" v-if="subscriptIndex == 0 && !graffiti">
      <img :src="switchs ? require('../assets/images/edit_icon_paint_n.png') : require('../assets/images/edit_icon_paint_s.png')" @click="show" alt="" />
      <el-color-picker v-show="!switchs" v-model="strokeStyle"></el-color-picker>
      <img v-if="!switchs" src="../assets/images/edit_icon_cancel.png" @click="repeal" alt="" />
      <img v-if="!switchs" src="../assets/images/edit_icon_initial.png" @click="resetAll" alt="" />
      <img v-if="!switchs" src="../assets/images/edit_icon_save.png" @click="downLoad" alt="" />
    </div>
    <!-- <div class="drawTop" ref="drawTop" v-if="lineStep == lineNum">
      <div>
        <el-button type @click="resetAll">清空</el-button>
        <el-button type @click="repeal">撤销</el-button>
        <el-button type @click="canvasRedo">恢复</el-button>
        <el-button type @click="downLoad">下载</el-button>
      </div>
      <div style="width: 22%">
        选择绘制类型:
        <el-radio-group v-model="type" size="medium">
          <el-radio-button v-for="(item, index) in typeOption" :key="index" :label="item.value" @click.native="radioClick(item.value)">{{ item.label }} </el-radio-button>
        </el-radio-group>
      </div>
      <div style="width: 15%">
        边框粗细:
        <el-slider v-model="lineWidth" :min="0" :max="10" :step="1" style="width: 70%"></el-slider>
      </div>
      <div>
        线条颜色:
        <el-color-picker v-model="strokeStyle"></el-color-picker>
      </div>
      <div>
        文字颜色:
        <el-color-picker v-model="fontColor"></el-color-picker>
      </div>
      <div style="width: 15%">
        文字大小:
        <el-slider v-model="fontSize" :min="14" :max="36" :step="2" style="width: 70%"></el-slider>
      </div>
    </div> -->

    <!-- <div style="height: 100%; width: 100%; position: relative">
      <div class="content"></div>
      <input v-show="isShow" type="text" @blur="txtBlue" ref="txt" id="txt" style="z-index: 9999; border: 0; background: none; outline: none" />
    </div> -->
  </div>
</template>

<script>
// import upload from "@/api/upload"; // 引入
export default {
  name: 'callout',
  props: {
    imgPath: {},
    subscriptIndex: null,
    graffiti: {
      type: Boolean,
    },
    status: Boolean,
  },
  data() {
    return {
      isShow: false,
      canvas: '',
      ctx: '',
      ctxX: 0,
      ctxY: 0,
      lineWidth: 3,
      type: 'L',
      typeOption: [
        { label: '线', value: 'L' },
        { label: '矩形', value: 'R' },
        { label: '箭头', value: 'A' },
        { label: '文字', value: 'T' },
      ],
      canvasHistory: [],
      step: 0,
      loading: false,
      fillStyle: '#CB0707',
      strokeStyle: '#FF0000',
      lineNum: 2,
      linePeak: [],
      lineStep: 2,
      ellipseR: 0.5,
      dialogVisible: false,
      isUnfold: true,
      fontSize: 24,
      fontColor: '#FF0000',
      fontFamily: '微软雅黑',
      img: new Image(),
      switchs: true,
    };
  },
  watch: {
    // imgPath() {
    //   console.log(this.imgPath);
    //   this.initialization();
    // },
  },
  mounted() {
    // this.initialization();
  },
  methods: {
    show() {
      this.switchs = !this.switchs;
      let f = document.getElementsByClassName('el-button--text')[0];
      let child = f.childNodes;
      for (let i = child.length - 1; i >= 0; i--) {
        // const element = array[index];
        f.removeChild(child[i]);
      }
      var span = document.createElement('span');
      span.innerHTML = 'очист';
      f.appendChild(span);
      let b = document.getElementsByClassName('el-color-dropdown__btn')[0];
      let ch = b.childNodes;
      for (let i = ch.length - 1; i >= 0; i--) {
        b.removeChild(ch[i]);
      }
      var span = document.createElement('span');
      span.innerHTML = 'увер';
      b.appendChild(span);
      // let c = document.getElementsByClassName("canvas-container")[0];
      // var img = document.createElement("img");
      // img.src = this.imgPath.thumb;
      // console.log(img);
    },
    /**
     * 初始化配置
     */
    initialization() {
      // console.log(this.imgPath);
      let image = new Image();
      image.setAttribute('crossOrigin', 'anonymous');
      // console.log(this.imgPath.images);
      let i;
      try {
        this.imgPath.images.length;
      } catch (error) {
        // console.log(error);
        i = 0;
      }
      console.log(i);
      // console.log(this.imgPath.images.length);
      if (i == 0) {
        this.imgPath.images = [this.imgPath.thumb];
        // this.imgPath.id = this.imgPath.item_id;
      }
      // console.log(this.imgPath.images[0]);
      image.src = this.imgPath.graffiti_img ? this.imgPath.graffiti_img.split('?')[0] : this.imgPath.images[0].split('?')[0];
      image.src = image.src + '?imageMogr2/format/heif?imageMogr2/thumbnail/636x';
      // console.log(image, "ddddd");
      // image.src = this.getBase64(this.imgPath);
      image.onload = () => {
        //图片加载完，再draw 和 toDataURL
        if (image.complete) {
          this.img = image;
          let content = document.getElementsByClassName('aoligei')[0];
          this.canvas = document.createElement('canvas');
          this.canvas.id = 'canvas';
          this.canvas.height = 636;
          this.canvas.width = 636;
          console.log(content);
          this.ctx = this.canvas.getContext('2d');
          this.ctx.globalAlpha = 1;
          this.ctx.drawImage(this.img, 0, 0, this.img.width, this.img.height, 0, 0, 636, 636);
          this.canvasHistory.push(this.canvas.toDataURL());
          this.ctx.globalCompositeOperation = this.type;
          content.appendChild(this.canvas);
          this.$parent.$parent.load = false;
          this.bindEventLisner();
        }
      };
    },
    radioClick(item) {
      if (item != 'T') {
        this.txtBlue();
        this.resetTxt();
      }
    },
    dataURLtoFile(dataurl, filename) {
      //将base64转换为文件
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {
        type: mime,
      });
    },
    // 下载画布
    downLoad() {
      this.$parent.$parent.load = true;
      // let _this = this;
      let url = this.canvas.toDataURL('image/png');
      // console.log(url);
      // let fileName = "canvas.png";
      let file = new FormData();
      file.append('token', localStorage.getItem('token'));
      file.append('thumb', this.dataURLtoFile(url, 'canvas.png'));
      file.append('lang', 1);
      if (this.status) {
        file.append('item_id', this.imgPath.item_id);
        file.append('type', 2);
        file.append('order_id', this.imgPath.order_id);
      } else {
        file.append('item_id', this.imgPath.id);
        file.append('type', 1);
      }
      // console.log(file);
      this.api.graffiti(file).then((res) => {
        this.Toast(res);
        // console.log(res);
        this.$parent.$parent.load = false;
        this.$nextTick(() => {
          this.$parent.$parent.operationalData(res.data.path + '?imageMogr2/format/heif?imageMogr2/thumbnail/636x', this.imgPath.id);
          // this.$emit("operationalData", res.data.path);
        });
      });

      // upload(this.dataURLtoFile(url, "canvas.png"), (res) => {
      //   console.log(res);
      //   // this.avatar = res;
      // });
      // if ("download" in document.createElement("a")) {
      //   // 非IE下载
      //   const elink = document.createElement("a");
      //   elink.download = fileName;
      //   elink.style.display = "none";
      //   elink.href = url;
      //   document.body.appendChild(elink);
      //   elink.click();
      //   document.body.removeChild(elink);
      // } else {
      //   // IE10+下载
      //   navigator.msSaveBlob(url, fileName);
      // }
    },
    getBase64(url, callback) {
      var Img = new Image(),
        dataURL = '';
      Img.src = url + '?v=' + Math.random();
      Img.setAttribute('crossOrigin', 'Anonymous');
      Img.onload = function() {
        var canvas = document.createElement('canvas'),
          width = Img.width,
          height = Img.height;
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(Img, 0, 0, width, height);
        dataURL = canvas.toDataURL('image/jpeg');
        return callback ? callback(dataURL) : null;
      };
    },
    resetAll() {
      // this.switchs = true;
      // console.log(this.getBase64Image(this.imgPath.thumb));
      // document.getElementsByClassName("el-loading-mask")[0].style =
      //   "display:inline-block ;background:rgba(0,0,0,.3)!important;width:100% !important;height:100% !important";
      this.$parent.$parent.load = true;
      this.getBase64(this.imgPath.thumb, (res) => {
        console.log(res);

        let uploadFileName = Date.parse(new Date());
        this.dataURLtoFile(res, uploadFileName);
        // console.log(this.dataURLtoFile(res, uploadFileName + ".png"));
        // this.switchs = false;
        // this.$parent.$parent.load = false;
      });
      let url = this.imgPath.graffiti_img;
      this.imgPath.graffiti_img = this.imgPath.thumb.split('?')[0] + '?tamp=' + new Date().valueOf();
      let f = document.getElementsByClassName('aoligei')[0];
      let child = f.childNodes;
      for (let i = child.length - 1; i >= 0; i--) {
        // const element = array[index];
        f.removeChild(child[child.length - 1]);
      }
      // this.downLoad();
      this.initialization();
      this.$parent.$parent.operationalData(url);
    },
    // 清空当前画布
    reset() {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.ctx.drawImage(this.img, 0, 0);
      this.resetTxt();
    },
    // 撤销方法
    repeal() {
      // let _this = this;
      if (this.isShow) {
        this.resetTxt();
        this._repeal();
      } else {
        this._repeal();
      }
    },
    _repeal() {
      if (this.step >= 1) {
        this.step = this.step - 1;
        let canvasPic = new Image();
        canvasPic.src = this.canvasHistory[this.step];
        canvasPic.addEventListener('load', () => {
          this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
          this.ctx.drawImage(canvasPic, 0, 0);
          this.loading = true;
        });
      } else {
        this.$message.warning('Нельзя продолжать отменять');
      }
    },
    // 恢复方法
    canvasRedo() {
      if (this.step < this.canvasHistory.length - 1) {
        if (this.step == 0) {
          this.step = 1;
        } else {
          this.step++;
        }
        let canvasPic = new Image();
        canvasPic.src = this.canvasHistory[this.step];
        canvasPic.addEventListener('load', () => {
          this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
          this.ctx.drawImage(canvasPic, 0, 0);
        });
      } else {
        this.$message.warning('Это последняя запись');
      }
    },
    // 绘制历史数组中的最后一个
    rebroadcast() {
      let canvasPic = new Image();
      canvasPic.src = this.canvasHistory[this.step];
      canvasPic.addEventListener('load', () => {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.ctx.drawImage(canvasPic, 0, 0);
        this.loading = true;
      });
    },
    // 绑定事件,判断分支
    bindEventLisner() {
      // let _this = this;

      let r1, r2; // 绘制圆形，矩形需要
      this.canvas.onmousedown = (e) => {
        // console.log("onmousedown");
        if (!this.switchs) {
          if (this.type == 'L') {
            this.createL(e, 'begin');
          } else if (this.type == 'R') {
            r1 = e.layerX;
            r2 = e.layerY;
            this.createR(e, 'begin', r1, r2);
          } else if (this.type == 'A') {
            this.drawArrow(e, 'begin');
          } else if (this.type == 'T') {
            this.createT(e, 'begin');
          }
        }
      };
      this.canvas.onmouseup = (e) => {
        if (!this.switchs) {
          if (this.type == 'L') {
            this.createL(e, 'end');
          } else if (this.type == 'R') {
            this.createR(e, 'end', r1, r2);
            r1 = null;
            r2 = null;
          } else if (this.type == 'A') {
            this.drawArrow(e, 'end');
          } else if (this.type == 'T') {
            this.createT(e, 'end');
          }
        }
        // console.log("onmouseup");
      };
      // this.$nextTick(() => {
      this.$parent.$parent.loads();
      // this.$emit("loads");
      // });
    },
    // 绘制线条
    createL(e, status) {
      // let _this = this;
      if (status == 'begin') {
        this.ctx.beginPath();
        this.ctx.moveTo(e.layerX, e.layerY);
        this.canvas.onmousemove = (e) => {
          // console.log("onmousemove");
          this.ctx.lineTo(e.layerX, e.layerY);
          this.ctx.strokeStyle = this.strokeStyle;
          this.ctx.lineWidth = this.lineWidth;
          this.ctx.stroke();
        };
      } else if (status == 'end') {
        this.ctx.closePath();
        this.step = this.step + 1;
        if (this.step < this.canvasHistory.length - 1) {
          this.canvasHistory.length = this.step; // 截断数组
        }
        this.canvasHistory.push(this.canvas.toDataURL());
        this.canvas.onmousemove = null;
      }
    },
    // 绘制矩形
    createR(e, status, r1, r2) {
      // let _this = this;
      let r;
      if (status == 'begin') {
        // console.log("onmousemove");
        this.canvas.onmousemove = (e) => {
          this.reset();
          let rx = e.layerX - r1;
          let ry = e.layerY - r2;

          //保留之前绘画的图形
          if (this.step !== 0) {
            let canvasPic = new Image();
            canvasPic.src = this.canvasHistory[this.step];
            this.ctx.drawImage(canvasPic, 0, 0);
          }

          this.ctx.beginPath();
          this.ctx.strokeRect(r1, r2, rx, ry);
          this.ctx.strokeStyle = this.strokeStyle;
          this.ctx.lineWidth = this.lineWidth;
          this.ctx.closePath();
          this.ctx.stroke();
        };
      } else if (status == 'end') {
        this.rebroadcast();
        let interval = setInterval(() => {
          if (this.loading) {
            clearInterval(interval);
            this.loading = false;
          } else {
            return;
          }
          let rx = e.layerX - r1;
          let ry = e.layerY - r2;
          this.ctx.beginPath();
          this.ctx.rect(r1, r2, rx, ry);
          this.ctx.strokeStyle = this.strokeStyle;
          this.ctx.lineWidth = this.lineWidth;
          this.ctx.closePath();
          this.ctx.stroke();
          this.step = this.step + 1;
          if (this.step < this.canvasHistory.length - 1) {
            this.canvasHistory.length = this.step; // 截断数组
          }
          this.canvasHistory.push(this.canvas.toDataURL());
          this.canvas.onmousemove = null;
        }, 1);
      }
    },

    //绘制箭头
    drawArrow(e, status) {
      // let _this = this;
      if (status == 'begin') {
        //获取起始位置
        this.arrowFromX = e.layerX;
        this.arrowFromY = e.layerY;
        this.ctx.beginPath();
        this.ctx.moveTo(e.layerX, e.layerY);
      } else if (status == 'end') {
        //计算箭头及画线
        let toX = e.layerX;
        let toY = e.layerY;
        let theta = 30;
        let headlen = 10;
        // let _this = this;
        let fromX = this.arrowFromX;
        let fromY = this.arrowFromY;
        // 计算各角度和对应的P2,P3坐标
        let angle = (Math.atan2(fromY - toY, fromX - toX) * 180) / Math.PI,
          angle1 = ((angle + theta) * Math.PI) / 180,
          angle2 = ((angle - theta) * Math.PI) / 180,
          topX = headlen * Math.cos(angle1),
          topY = headlen * Math.sin(angle1),
          botX = headlen * Math.cos(angle2),
          botY = headlen * Math.sin(angle2);
        let arrowX = fromX - topX,
          arrowY = fromY - topY;
        this.ctx.moveTo(arrowX, arrowY);
        this.ctx.moveTo(fromX, fromY);
        this.ctx.lineTo(toX, toY);
        arrowX = toX + topX;
        arrowY = toY + topY;
        this.ctx.moveTo(arrowX, arrowY);
        this.ctx.lineTo(toX, toY);
        arrowX = toX + botX;
        arrowY = toY + botY;
        this.ctx.lineTo(arrowX, arrowY);
        this.ctx.strokeStyle = this.strokeStyle;
        this.ctx.lineWidth = this.lineWidth;
        this.ctx.stroke();

        this.ctx.closePath();
        this.step = this.step + 1;
        if (this.step < this.canvasHistory.length - 1) {
          this.canvasHistory.length = this.step; // 截断数组
        }
        this.canvasHistory.push(this.canvas.toDataURL());
        this.canvas.onmousemove = null;
      }
    },

    //文字输入
    createT(e, status) {
      // let _this = this;
      if (status == 'begin') {
      } else if (status == 'end') {
        let offset = 0;
        if (this.fontSize >= 28) {
          offset = this.fontSize / 2 - 3;
        } else {
          offset = this.fontSize / 2 - 2;
        }
        this.ctxX = e.layerX + 2;
        this.ctxY = e.layerY + offset;
        let index = this.getPointOnCanvas(e);
        this.$refs.txt.style.left = index.x + 'px';
        this.$refs.txt.style.top = index.y - this.fontSize / 2 + 'px';
        this.$refs.txt.value = '';
        this.$refs.txt.style.height = this.fontSize + 'px';
        (this.$refs.txt.style.width = this.canvas.width - e.layerX - 1 + 'px'), (this.$refs.txt.style.fontSize = this.fontSize + 'px');
        this.$refs.txt.style.fontFamily = this.fontFamily;
        this.$refs.txt.style.color = this.fontColor;
        this.$refs.txt.style.maxlength = Math.floor((this.canvas.width - e.layerX) / this.fontSize);
        this.isShow = true;
        setTimeout(() => {
          this.$refs.txt.focus();
        });
      }
    },
    //文字输入框失去光标时在画布上生成文字
    txtBlue() {
      // let _this = this;
      let txt = this.$refs.txt.value;
      if (txt) {
        this.ctx.font = this.$refs.txt.style.fontSize + ' ' + this.$refs.txt.style.fontFamily;
        this.ctx.fillStyle = this.$refs.txt.style.color;
        this.ctx.fillText(txt, this.ctxX, this.ctxY);
        this.step = this.step + 1;
        if (this.step < this.canvasHistory.length - 1) {
          this.canvasHistory.length = this.step; // 截断数组
        }
        this.canvasHistory.push(this.canvas.toDataURL());
        this.canvas.onmousemove = null;
      }
    },
    //计算文字框定位位置
    getPointOnCanvas(e) {
      let cs = this.canvas;
      let content = document.getElementsByClassName('content')[0];
      return {
        x: e.layerX + (content.clientWidth - cs.width) / 2,
        y: e.layerY,
      };
    },
    //清空文字
    resetTxt() {
      // let _this = this;
      this.$refs.txt.value = '';
      this.isShow = false;
    },
  },
};
</script>

<style lang="less" scope>
* {
  box-sizing: border-box;
}

.specification {
  width: 636px;
  height: 50px;
  background: #333333;
  opacity: 1;
  padding: 13px 40px;
  position: absolute;
  // left: 20px;
  // bottom: 34px;
  img:last-child {
    margin-right: 0;
  }
  img {
    width: 24px;
    height: 24px;
    object-fit: cover;
    margin-right: 109px;
  }
}

.draw {
  position: relative;
  height: 50px;
  min-width: 420px;
  width: 636px;
  display: inline-block;
  display: flex;
  flex-direction: column;
}

.content {
  flex-grow: 1;
  height: 100%;
  width: 100%;
}

.drawTop {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 5px;
  height: 52px;
}

.drawTop > div {
  display: flex;
  align-items: center;
  padding: 5px 5px;
}

div.drawTopContrllor {
  display: none;
}

@media screen and (max-width: 1200px) {
  .drawTop {
    position: absolute;
    background-color: white;
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    height: 30px;
    overflow: hidden;
  }

  .drawTopContrllor {
    display: flex !important;
    height: 30px;
    width: 100%;
    justify-content: center;
    align-items: center;
    padding: 0 !important;
  }
}
</style>
